import { ModalOverlay } from './ModalOverlay';

interface Props {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  pending?: boolean;
  danger?: boolean;
  error?: string | null;
}

export function ConfirmModal({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  pending = false,
  danger = false,
  error,
}: Props) {
  return (
    <ModalOverlay
      onBackdrop={() => {
        if (!pending) onCancel();
      }}
      ariaLabelledby="confirm-modal-title"
    >
      <div className="flex items-center justify-between gap-3">
        <h2 id="confirm-modal-title" className="text-lg font-bold text-text-primary">
          {title}
        </h2>
        <button
          type="button"
          onClick={onCancel}
          disabled={pending}
          className="text-xl text-text-secondary"
          aria-label={cancelLabel}
        >
          ×
        </button>
      </div>
      <p className="mt-2 text-sm text-text-secondary">{message}</p>
      {error && (
        <p role="alert" className="parte-error mt-3">
          {error}
        </p>
      )}
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          onClick={onCancel}
          disabled={pending}
          className="flex-1 rounded-md border border-border px-4 py-2 text-sm font-medium text-text-primary hover:bg-background"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={pending}
          className={`flex-1 rounded-md px-4 py-2 text-sm font-medium hover:opacity-90 disabled:opacity-50 ${
            danger ? 'bg-warning-bg text-warning-text' : 'bg-accent text-accent-contrast'
          }`}
        >
          {confirmLabel}
        </button>
      </div>
    </ModalOverlay>
  );
}
